import { Div, Text, Image, Link, Span, Paragraph } from "@tblabs/truffle";
import { BasketItem } from "../../../../../../Models/Basket/BasketItem";
import { TableEntry } from "./TableEntry";
import { RentBasketItem } from "../../../../../../Models/Basket/RentBasketItem";
import { TimeUtils } from "../../../../../../Utils/TimeUtils";


// export class SerialNumberPrinter extends Div
// {
//     constructor(x: BasketItem)
//     {
//         super();

//         const input = x.ProductSerialNumber.value;
//         const e = input.match(/TX(\d+)/);
//         const extractedTXid = e?.[0];

//         this.Append(
//             new Text(x.ProductSerialNumber).WidthAuto().DisplayInline().Bold().Color("#666"),
//             extractedTXid && "\n",
//             extractedTXid && new Link("🚀" + extractedTXid).WidthAuto().DisplayInline().Bold().Color("#007bff"),
//         );
//     }
// }

export class AdminBasketTableItem extends TableEntry
{
    constructor(x: BasketItem)
    {
        const dates = (x instanceof RentBasketItem) ? TimeUtils.FormattedRange(x.From, x.To) : "";
        super({
            Content: [
                new Div("basket-cart-item").Append(
                    new Image(x.ProductInfo.Picture, x.ProductInfo.Name).Class("basket-cart-item-image"),
                    new Div("basket-cart-item-details").Append(
                        new Link(x.ProductInfo.Name, x.ProductInfo.Link),
                        x.Quantity.value > 1 && new Span(`×${x.Quantity.value}`).MarginLeft(8),
                        new Div("basket-cart-item-dates").Text(`${x.Option.Name || ""}`),
                        dates && new Div("basket-cart-item-dates").Text(`${dates}`),
                        // new SerialNumberPrinter(x),
                        new Text(x.ProductSerialNumber).WidthAuto().DisplayInline().Bold().Color("#666"),
                        x.AccessData.value && " 🧩",
                    )
                )
            ],
        });
    }
}


export class AdminBasketTableItemV2 extends Div
{
    constructor(x: BasketItem)
    {
        const dates = (x instanceof RentBasketItem) ? TimeUtils.FormattedRange(x.From, x.To) : "";

        super("product-item");

        this.Append(
            new Div("product-item__info").Append(
                new Image(x.ProductInfo.Picture, x.ProductInfo.Name).Class("product-item__image"),
                new Div("product-item__details").Append(
                    new Link(x.ProductInfo.Name + " / " + (x.Option.Name || "(opcja domyślna)"), x.ProductInfo.Link),
                    dates && new Paragraph("product-item__dates").Text(`Wypożyczenie ${dates}`),
                    new Text(x.ProductSerialNumber).Bold(),
                ),
            ),
            new Div("product-item__pricing").Append(
                new Paragraph("product-item__quantity").Text(`Id: ${x.Id}`).FontSize(12).Color("#ddd"), // TODO: można to jakoś poprawić
                new Paragraph("product-item__price").Text(x.TotalPrice.value + " zł"),
                new Paragraph("product-item__quantity").Text(`Ilość: ${x.Quantity.value}`),
            ),
        );
    }
}
